import {
    MEDIA_VIEWER_CONTENT_TYPES,
    MediaViewerContentType,
} from '../enums/media-viewer-content-types';

/**
 * Maps a MIME or media-viewer content-type string to {@link MediaViewerContentType}.
 *
 * @param mime MIME type (e.g. `application/pdf`).
 * @returns Matching enum value, or `undefined` when the media viewer cannot display it.
 */
export function mimeToMediaViewerContentType(
    mime: string | null | undefined
): MediaViewerContentType | undefined {
    if (mime == null) {
        return undefined;
    }

    const normalized = mime.trim().toLowerCase();
    if (normalized.length === 0) {
        return undefined;
    }

    return MEDIA_VIEWER_CONTENT_TYPES.find(
        (contentType) => contentType === normalized
    );
}
